<template>
  <div class="main-container">
    <operation-header
      @search="search"
      :selected_tab="selected_tab"
      @selectTab="selectTab"
      @showDownloadFilters="showDownloadFiltersMenu"
      @quickSearch="quickSearch"
      :showClientIdInfo="showClientIdInfo"
    ></operation-header>
    
    <!-- TODO: SHOW CALENDAR SALES ORDER VIEW WHEN REQUEST BY BUSINESS -->
    <!-- v-if="selected_tab === 'list'" -->

    <OperationTable
      v-if="selected_tab"
      ref="OperationTable"
      :showDownloadFilters="showDownloadFilters"
      @resetSearch="showDownloadFilters = false"
      :showClientIdInfo="showClientIdInfo"
    />

    <!-- TODO: SHOW CALENDAR SALES ORDER VIEW WHEN REQUEST BY BUSINESS -->
    <!-- <div v-else-if="selected_tab === 'calendar'">
      <div>
        <div class="row align-items-center">
          <div class="col-4 ms-auto">
            <div class="filter-drivers">
              <b-sidebar
                id="sidebar-backdrop"
                :backdrop-variant="variant"
                bg-variant="white"
                backdrop
                :right="!isLangRtl"
                shadow
              >
                <div class="px-3 py-2">
                  <h4 class="filter-drivers__head">{{ $t("filter-by") }}</h4>
                  <hr />
                  <base-select
                    v-if="!$store.getters['enums/user_info'].branch"
                    name="Branch"
                    label="branch"
                    :options="$store.getters['enums/branch_enums']"
                    :small="true"
                    field="selected_brand"
                    :value="searchPayload.branch"
                    @change-value="getBranch"
                  >
                  </base-select>
                  <base-select
                    name="client"
                    label="client"
                    :options="$store.getters['enums/clients_list_enums']"
                    :small="true"
                    field="selected_brand"
                    :value="searchPayload.client"
                    @change-value="getClient"
                    :disabled="autofill_client ? true : false"
                  >
                  </base-select>

                  <base-select
                    name="Service"
                    label="service"
                    :options="$store.getters['enums/services_type_list_enums']"
                    :small="true"
                    field="selected_brand"
                    :value="searchPayload.service"
                    @change-value="getService"
                  >
                  </base-select>
                  <base-select
                    name="Reservation Status"
                    label="reservation-status"
                    :options="reservationStatusOptions"
                    :small="true"
                    field="selected_brand"
                    :value="searchPayload.status"
                    @change-value="getStatus"
                    :useI18n="true"
                  >
                  </base-select>

                  <div>
                    <label
                      class="datepicker-placeholder"
                      for="datepicker-placeholder"
                    >
                      {{ $t("date-of-reservation") }}
                    </label>

                    <div class="row">
                      <div class="col-6 mt-2">
                        <div class="form-label label-text">
                          {{ $t("from") }}
                        </div>
                        <div class="input-group">
                          <b-modal
                            :id="modalFromId"
                            ref="modalFromId"
                            centered
                            hide-header
                            hide-footer
                            no-fade
                            static
                            content-class="w-auto mx-auto"
                          >
                            <b-calendar
                              v-model="searchPayload.startDate"
                              @context="(ctx) => (dateFromContext = ctx)"
                              @input="$refs.modalFromId.hide()"
                            >
                            </b-calendar>
                          </b-modal>
                          <b-input-group v-b-modal="modalFromId">
                            <label
                              class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                            >
                              <span
                                v-if="!dateFromContext.selectedYMD"
                                class="time-placeHolder"
                                >{{ $t("select-date") }}</span
                              >
                              {{ dateFromContext.selectedYMD }}
                              <img
                                :src="
                                  require(`@/assets/images/icons/select-time.svg`)
                                "
                                alt="select time"
                              />
                            </label>
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6 mt-2">
                        <div class="form-label label-text">
                          {{ $t("to") }}
                        </div>
                        <div class="input-group">
                          <b-modal
                            :id="modalToId"
                            ref="modalToId"
                            centered
                            hide-header
                            hide-footer
                            no-fade
                            static
                            content-class="w-auto mx-auto"
                          >
                            <b-calendar
                              v-model="searchPayload.endDate"
                              @context="(ctx) => (dateToContext = ctx)"
                              @input="$refs.modalToId.hide()"
                            >
                            </b-calendar>
                          </b-modal>
                          <b-input-group v-b-modal="modalToId">
                            <label
                              class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer"
                            >
                              <span
                                v-if="!dateToContext.selectedYMD"
                                class="time-placeHolder"
                                >{{ $t("select-date") }}</span
                              >
                              {{ dateToContext.selectedYMD }}
                              <img
                                :src="
                                  require(`@/assets/images/icons/select-time.svg`)
                                "
                                alt="select time"
                              />
                            </label>
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <base-button
                    class="search-btn primary mt-4 mb-3"
                    @click="search"
                  >
                    {{ $t("search") }}
                  </base-button>
                  <base-button
                    class="reset-btn mb-1"
                    @click="resetSearchPayload"
                  >
                    {{ $t("reset-filters") }}
                  </base-button>
                </div>
              </b-sidebar>
            </div>
          </div>
        </div>
        <Calendar
          :loading="loading"
          :events="events"
          @refreshData="search"
          @getMonth="getSelectedDate"
        />
      </div>
    </div> -->
    <div v-else class="title d-flex align-items-center justify-content-center">
      {{ $t("no-view-found") }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
import OperationHeader from "@/components/Operations/Listing/operationHeader.vue";
import OperationTable from "@/components/Operations/Listing/operationTable.vue";
import Calendar from "@/components/Operations/calendar/index.vue";
import NewReservationService from "@/services/new-reservation.service";
import { nanoid } from "nanoid";

export default {
  name: "OperationsView",
  components: { OperationHeader, OperationTable, Calendar },
  data() {
    return {
      events: [],
      selected_tab: "list",
      filterBtnHovered: false,
      loading: false,
      showDownloadFilters: false,
      reservationStatusOptions: [
        { text: "select-an-option", value: null },
        { text: "quotation", value: "quotation" },
        { text: "sales-order", value: "sales-order" },
        { text: "draft-sales-order", value: "draft-sales-order" },
        { text: "canceled", value: "cancelled" },
      ],
      searchPayload: {
        branch: null,
        client: null,
        service: null,
        status: null,
        endDate: null,
        startDate: null,
      },
      variant: "transparent",
      modalFromId: "date-picker-modal1",
      modalToId: "date-picker-modal2",
      dateFromContext: {},
      dateToContext: {},
      rows: 0,
      perPage: 15,
      autofill_client: null,
      startDateUTCString: null,
      endDateUTCString: null,
      DateUTCString: null,
      selected_view: null,
    };
  },
  methods: {
    quickSearch(option, value) {
      this.$refs.OperationTable.quickSearch(option, value);
    },
    getSelectedDate(date, view) {
      const dateISO = date.toISOString();
      this.DateUTCString = dateISO;
      this.selected_view = view;
    },
    getBranch(branch) {
      this.searchPayload.branch = branch;
    },
    getClient(client) {
      this.searchPayload.client = client;
    },
    getService(service) {
      this.searchPayload.service = service;
    },
    getStatus(Status) {
      this.searchPayload.status = Status;
    },
    resetSearchPayload() {
      this.searchPayload.branch = null;
      if (!this.autofill_client) this.searchPayload.client = null;
      this.searchPayload.service = null;
      this.searchPayload.status = null;
      this.searchPayload.endDate = null;
      this.searchPayload.startDate = null;
      this.search();
    },
    async search() {
      this.loading = true;
      let params = new URLSearchParams();

      params.append("limit", 90);
      params.append("sort", "-created_on");
      params.append("type", "ne:Contract");

      if (this.DateUTCString) {
        if (this.selected_view == "monthly") {
          const selectedDate = new Date(this.DateUTCString);
          const selectedMonth = selectedDate.getMonth() + 1;
          const selectedYear = selectedDate.getFullYear();

          const startDate = new Date(selectedYear, selectedMonth - 1, 1); // First day of the month
          startDate.setUTCHours(0, 0, 0, 0);
          const endDate = new Date(selectedYear, selectedMonth, 1);
          endDate.setUTCHours(23, 59, 59, 999);

          const startDateUTCString = startDate.toISOString();
          const endDateUTCString = endDate.toISOString();
          params.append(
            "fromCalendarDate",
            startDateUTCString.substring(0, 10)
          );
          params.append("toCalendarDate", endDateUTCString.substring(0, 10));
        } else if (this.selected_view == "weekly") {
          const selectedDate = moment(this.DateUTCString);

          const startDate = new Date(selectedDate.clone().weekday(0)); // First day of the week
          startDate.setUTCHours(0, 0, 0, 0); // Last day of the week
          const endDate = new Date(selectedDate.clone().weekday(6));
          endDate.setUTCHours(23, 59, 59, 999);

          const startDateUTCString = startDate.toISOString();
          const endDateUTCString = endDate.toISOString();
          params.append(
            "fromCalendarDate",
            startDateUTCString.substring(0, 10)
          );
          params.append("toCalendarDate", endDateUTCString.substring(0, 10));
        } else {
          params.append(
            "fromCalendarDate",
            this.DateUTCString.substring(0, 10)
          );
          params.append("toCalendarDate", this.DateUTCString.substring(0, 10));
        }
      } else {
        const selectedDate = new Date();
        params.append(
          "fromCalendarDate",
          selectedDate.toISOString().substring(0, 10)
        );
        params.append(
          "toCalendarDate",
          selectedDate.toISOString().substring(0, 10)
        );
      }

      if (this.searchPayload.service)
        params.append("service", this.searchPayload.service);

      if (this.$store.getters["enums/user_info"].branch) {
        params.append("branch", this.$store.getters["enums/user_info"].branch);
      } else if (this.searchPayload.branch) {
        params.append("branch", this.searchPayload.branch);
      }

      if (this.autofill_client || this.searchPayload.client)
        params.append(
          "client",
          this.autofill_client || this.searchPayload.client
        );
      if (this.searchPayload.status)
        params.append("status", this.searchPayload.status);
      if (this.searchPayload.startDate)
        params.append("startDate", "gte:" + this.searchPayload.startDate);

      if (this.searchPayload.endDate) {
        const date = new Date(this.searchPayload.endDate);
        date.setHours(24);
        date.setMinutes(59);
        params.append(
          "startDate",
          "lte:" + this.searchPayload.endDate + "T23:59:59.000Z"
        );
      }

      params.append(
        "select",
        "id,services.trips.slotsUsed,services.trips.scheduledStartDate,services.trips.scheduledStartTime,services.trips.scheduledEndDate,services.trips.scheduledEndTime,status,startDate,endDate,services.trips.startLocation,services.trips.endLocation,services.service.name,services.service.arabicName,client._id,client.name,client.arabicName,product._id,product.name,product.arabicName,branch.name,branch._id,branch.arabicName,created_by,paymentLinkExpiryDate,paymentLink,client.paymentMethod"
      );

      try {
        const response = await NewReservationService.search(params);
        let events = [];

        for (let j = 0; j < response.items.length; j++) {
          const each = response.items[j];
          if (each?.services?.length)
            for (let s = 0; s < each.services.length; s++) {
              const service = each.services[s];
              if (service?.trips?.length)
                for (let i = 0; i < service.trips.length; i++) {
                  const trip = service.trips[i];
                  events.push({
                    id: each?.id,
                    trip_id: trip?._id,
                    client: this.isLangRtl
                      ? each?.client?.arabicName
                      : each?.client?.name || "",
                    service: service?.service,
                    branch: this.isLangRtl
                      ? each?.branch?.arabicName
                      : each?.branch?.name || "",
                    date_of_initial_reservation: each?.startDate,
                    number_of_trips: 1,
                    trips: each?.trips,
                    type: each?.status,
                    start_time: moment(trip?.scheduledStartTime)
                      .add(0, "days")
                      .set("hour", 12)
                      .set("minutes", 0)
                      .set("seconds", 0),
                    end_time: moment(trip?.scheduledEndTime)
                      .add(0, "days")
                      .set("hour", 13)
                      .set("minutes", 0)
                      .set("seconds", 0),
                    date: moment(trip?.scheduledStartDate),
                    startLocation: trip?.startLocation,
                    endLocation: trip?.endLocation,
                    clientData: each?.client,
                    clientId: each?.client?._id,
                    clientName: each?.client?.name,
                    clientArabicName: each?.client?.arabicName,
                    serviceId: service?.service?._id,
                    serviceName: service?.service?.name,
                    serviceArabicName: service?.service?.arabicName,
                    branch: each?.branch?.name,
                    branchId: each?.branch?._id,
                    branchArabicName: each?.branch?.arabicName,
                    slotsPerDay: trip?.slotsUsed,
                    created_by: each?.created_by || "---",
                    paymentLinkExpiryDate: each?.paymentLinkExpiryDate,
                    paymentLink: each?.paymentLink,
                    paymentMethod: each?.client?.paymentMethod,
                  });
                }
            }
        }

        this.events = events;
        this.rows = response.total;
        this.loading = false;
      } catch (error) {
        this.error = error.message;
        this.loading = false;
      }
    },
    selectTab(tab) {
      if (this.$route?.params?.view !== tab) {
        this.$router.push(`/operations/${tab}`).catch(() => {});
      }
    },
    showDownloadFiltersMenu() {
      this.showDownloadFilters = nanoid();
    },
  },
  computed: {
    clientInfo() {
      return this.$store.getters["enums/client_info"];
    },
    showClientIdInfo() {
      return !isNaN(this.$route?.query?.clientID);
    }
  },
  watch: {
    clientInfo: {
      immediate: true,
      handler(info) {
        if (info?._id) {
          this.searchPayload.client = info?._id;
          this.autofill_client = info?._id;
        }
      },
    },
    DateUTCString(val, new_val) {
      if (val && new_val && val !== new_val) this.search();
    },
    selected_view(val) {
      if (val) this.search();
    },
    // selected_tab(newVal) {
    //   if (newVal === "calendar") this.search();
    // },
    $route(val) {
      if (val?.params?.view) {
        this.selected_tab = val.params.view;
      }
    },
  },
  mounted() {
    if (this.$route?.params?.view) {
      this.selected_tab = this.$route.params.view;
    }
  },
  created() {
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
    this.$store.dispatch("enums/GET_SERVICE_TYPE_ENUMS");
    this.$store.dispatch("enums/GET_PRODUCT_ENUMS");
    this.$store.dispatch("enums/GET_CLIENT_ENUMS");
    this.$store.dispatch("enums/GET_RESERVATION_CATEGORY_ENUMS");
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>
